import React, { ReactNode } from 'react'
import Button from '../../../components/common/Button'
import styled from '@emotion/styled'
import { Authorize } from '../../../components/Authorize'
import { ROLE } from '../../../services/user/user-typed'

const Layout = styled.div`
  display: flex;
  flex: 1;
  flex-flow: row;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  padding-right: 16px;
`

const ButtonStyled = styled(Button)`
  padding: 7px 13px;
`

type Props = {
  editMode: boolean
  onEdit: () => void
  onCreate: () => void
}

const CategoryTableTopbar = (props: Props) => {
  const { editMode, onEdit, onCreate } = props
  return (
    <Layout>
      <Authorize role={ROLE.MANAGER}>
        {editMode ? (
          <div style={{ display: 'flex', gap: '8px' }}>
            <ButtonStyled variant="success" onClick={onCreate}>
              Create Category
            </ButtonStyled>
          </div>
        ) : (
          <ButtonStyled variant="warning" onClick={onEdit}>
            Edit
          </ButtonStyled>
        )}
      </Authorize>
    </Layout>
  )
}

export default CategoryTableTopbar
